/* eslint-disable complexity */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import style from "./styles.css";
import useToggle from "../../../hooks/use-toggle";
import Button from "../../shared/button";

const MAX_LENGTH = 6;

const InputGroupAppend = ({
    value = "",
    id = "",
    // text = "",
    onChange,
    isAutoFocused = false,
    onBlurCallback = () => { },
    maxLength = MAX_LENGTH,
    validator = () => { },
    errorMessage = "Please enter a valid pincode",
    serverErrorMessage = "",
    inputRef,
    disabled = false,
    placeholder = "Enter pincode",
    onFocusCallback = () => { },
    showErrorOnFocus = false,
    type = "text",
    showValidCheckmark = false,
    onKeyPress = () => {},
    readOnly = false,
    onSubmitHandler = () => {},
    isError = false,
    isLoading = false

}) => {
    const [isTouched, setIsTouched] = useState(false);
    const [isFocused, setIsFocused] = useToggle(isAutoFocused);
    const [hasError, setHasError] = useState(false);
    const [error, setError] = useState(errorMessage);

    useEffect(() => {
        if (isError) {
            setError(serverErrorMessage);
        }
    }, [serverErrorMessage, isError]);

    const onFocus = (e) => {
        const inputValue = e.target.value;
        setIsFocused();
        setIsTouched(true);
        if (!validator(inputValue) && showErrorOnFocus) {
            setHasError(true);
            setError(errorMessage);
        } else {
            setHasError(false);
            setError("");
        }
        onFocusCallback();
    };

    const onBlur = (e) => {
        setIsFocused();
        onBlurCallback(e.target.value);
    };

    useEffect(() => {
        if (showValidCheckmark) {
            setHasError(!validator(value));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeHandler = (e) => {
        const regNumbers = /^\d{0,10}$/;
        if (regNumbers.test(e.target.value)) {
            onChange(e);
        }
    };
    return (
        <React.Fragment>
            <div styleName="style.inputWrapper">
                <input
                    className="form-control"
                    // aria-label="Enter pincode"
                    // aria-describedby="basic-addon2"
                    ref={inputRef}
                    id={id}
                    type={type}
                    // styleName={isAutoFocused ?
                    //     "styles.focused" : ""}
                    value={value}
                    maxLength={maxLength}
                    onChange={onChangeHandler}
                    onFocus={(e) => onFocus(e)}
                    onBlur={(e) => onBlur(e)}
                    autoComplete="off"
                    placeholder={placeholder}
                    disabled={disabled}
                    onKeyPress={onKeyPress}
                    readOnly={readOnly}
                />
                <Button isLoading={isLoading} text="APPLY" onClick={onSubmitHandler}/>
            </div>
            {
                (isError || (isTouched && !isFocused && hasError) || (showErrorOnFocus && hasError) || (isTouched && hasError))  &&
                    <div styleName="style.inputError">{error}</div>
            }
        </React.Fragment>

    );
};

InputGroupAppend.propTypes = {
    value: PropTypes.string,
    id: PropTypes.string,
    text: PropTypes.string,
    onChange: PropTypes.func,
    onBlurCallback: PropTypes.func,
    maxLength: PropTypes.number,
    validator: PropTypes.func,
    errorMessage: PropTypes.string,
    inputRef: PropTypes.object,
    onFocusCallback: PropTypes.func,
    placeholder: PropTypes.string,
    isAutoFocused: PropTypes.bool,
    disabled: PropTypes.bool,
    showErrorOnFocus: PropTypes.bool,
    type: PropTypes.number,
    showValidCheckmark: PropTypes.bool,
    onKeyPress: PropTypes.func,
    readOnly: PropTypes.bool,
    onSubmitHandler: PropTypes.func,
    isError: PropTypes.bool,
    serverErrorMessage: PropTypes.string,
    isLoading: PropTypes.bool
};
export default InputGroupAppend;
